import { FormDropdownOption } from '@sparknz/spark-pattern-library';

import { DeviceGalleryQuery } from '__generated__/DeviceGalleryQuery.graphql';

export type GalleryProducts =
  DeviceGalleryQuery['response']['deviceGallery']['products'];
export type GalleryFilters =
  DeviceGalleryQuery['response']['deviceGallery']['filters'];

export type SortOption = {
  value: SortByValue;
  label: string;
};

export interface Filters {
  primaryColor: string[];
  brand: string[];
  price: number;
  compatibleSim: string[];
  networkCapability: string[];
}

// TODO: update typing once DESL and BM confirms 'date' sorting attribute
export type SortByValue =
  | 'featured'
  | 'deals-first'
  | 'date'
  | 'price-asc'
  | 'price-desc';

export interface FilterOption<T> extends FormDropdownOption<T> {
  count?: number;
}

export interface BrandProps {
  brandOptions: FilterOption<string>[];
  selectedBrandOptions: FilterOption<string>[];
  onBrandChange?: (options: FilterOption<string>[]) => void;
}

export interface ColorProps {
  colorOptions: FilterOption<string>[];
  selectedColorOptions: FilterOption<string>[];
  onColorChange?: (options: FilterOption<string>[]) => void;
}

export interface NetworkCapabilityProps {
  networkCapabilityOptions: FilterOption<string>[];
  selectedNetworkCapabilityOptions: FilterOption<string>[];
  onNetworkCapabilityChange?: (options: FilterOption<string>[]) => void;
}

export interface CompatibleSimProps {
  compatibleSimOptions: FilterOption<string>[];
  selectedCompatibleSimOptions: FilterOption<string>[];
  onCompatibleSimChange?: (options: FilterOption<string>[]) => void;
}

export enum FilterIds {
  Brand = 'brand',
  Price = 'price',
  CompatibleSim = 'compatibleSim',
  NetworkCapability = 'networkCapability',
  PrimaryColor = 'primaryColor',
  Sort = 'sort',
}
